import { Divider, Grid } from '@wework/dieter-ui'
import SpaceType from '../SidebarBlocks/SpaceType'
import React from 'react'
import EditSpaceAttributes from './EditSpaceAttributes'

export default function EditMeetingRoom({
  space,
  setShowLinkeage,
  roomData,
  setRoomData,
}) {
  if (!space) {
    return null
  }
  return (
    <div>
      <Grid style={{ marginTop: 24 }}>
        <SpaceType
          space={space}
          setRoomData={setRoomData}
          roomData={roomData}
        />
        <Divider light style={{ width: '100%' }} />
        <EditSpaceAttributes
          space={space}
          roomData={roomData}
          setRoomData={setRoomData}
        />
      </Grid>
    </div>
  )
}
